// utils/timezone.js
import { setCookie, getCookie } from './cookies';

const TIMEZONE_COOKIE_KEY = 'user_timezone';
const COOKIE_EXPIRY_DAYS = 30;

// Special value indicating timezone was checked but not set by user
export const TIMEZONE_EMPTY = 'empty';

/**
 * Save timezone to cookie.
 * If timezone is empty string or null, saves TIMEZONE_EMPTY marker.
 * This distinguishes "not loaded yet" from "loaded but not set".
 */
export function saveTimezone(timezone) {
    if (timezone && timezone.length > 0) {
        setCookie(TIMEZONE_COOKIE_KEY, timezone, COOKIE_EXPIRY_DAYS);
    } else {
        // Explicitly mark as "checked but empty" so we know user hasn't set it
        setCookie(TIMEZONE_COOKIE_KEY, TIMEZONE_EMPTY, COOKIE_EXPIRY_DAYS);
    }
}

/**
 * Get timezone from cookie.
 * Returns:
 * - null if not checked yet (cookie doesn't exist)
 * - TIMEZONE_EMPTY if checked but user hasn't set timezone
 * - IANA timezone string if set (e.g., 'America/Los_Angeles')
 */
export function getTimezone() {
    return getCookie(TIMEZONE_COOKIE_KEY) || null;
}

/**
 * Check if timezone is actually set (not empty marker and not null)
 */
export function hasTimezone() {
    const tz = getTimezone();
    return tz && tz !== TIMEZONE_EMPTY;
}
